function initializeIstemeliCategoryMenu(menu) {
  if (menu.dataset.istemeliCategoryReady === 'true') return;
  menu.dataset.istemeliCategoryReady = 'true';

  const toggle = menu.querySelector('[data-istemeli-category-toggle]');
  const items = Array.from(menu.querySelectorAll('.istemeli-categories__item'));

  function closeMenu() {
    menu.classList.remove('is-mobile-open');
    toggle?.setAttribute('aria-expanded', 'false');
    items.forEach((item) => item.removeAttribute('open'));
  }

  toggle?.addEventListener('click', () => {
    const willOpen = !menu.classList.contains('is-mobile-open');
    menu.classList.toggle('is-mobile-open', willOpen);
    toggle.setAttribute('aria-expanded', String(willOpen));
  });

  items.forEach((item) => {
    item.addEventListener('toggle', () => {
      if (!item.open) return;
      items.forEach((otherItem) => {
        if (otherItem !== item) otherItem.removeAttribute('open');
      });
    });
  });

  document.addEventListener('click', (event) => {
    if (!menu.contains(event.target)) closeMenu();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMenu();
  });
}

function initializeAllIstemeliCategoryMenus(root = document) {
  root.querySelectorAll('[data-istemeli-category-menu]').forEach(initializeIstemeliCategoryMenu);
}

document.addEventListener('DOMContentLoaded', () => initializeAllIstemeliCategoryMenus());
document.addEventListener('shopify:section:load', (event) => initializeAllIstemeliCategoryMenus(event.target));
